import {NciAdministration} from '@features/nciAdministration/NciAdministration';

const NciAdministrationPage = () => {
    return <NciAdministration />;
};

export default NciAdministrationPage;
